export default __webpack_public_path__ + "static/media/coi-expirience.43291e91.png";